import {
	ChannelCreateRequestModel,
	ChannelCreateViewModel,
	ChannelResponseModel,
	ChannelUpdateRequestModel,
	ChannelUpdateViewModel,
	ChannelViewModel,
} from './Channel.type';
import { PodcastStore } from '../../../stores/podcast';
import { Option } from '../Option/Option.type';
import { ChannelCategory } from './Channel.constant';

const Create = {
	fromViewToRequest: (data: ChannelCreateViewModel): ChannelCreateRequestModel => {
		return {
			...data,
			category: data.category.value,
		};
	},
};

const Update = {
	fromViewToRequest: (data: ChannelUpdateViewModel): ChannelUpdateRequestModel => {
		return {
			...data,
			category: data.category.value,
		};
	},
};

const Entity = {
	fromResponseToView: async (data: ChannelResponseModel): Promise<ChannelViewModel> => {
		const categories = PodcastStore.store.get().category.data;

		return {
			...data,
			category: (categories?.find((item) => item.value === data.category) as Option<ChannelCategory>) ?? {
				label: '',
				value: data.category,
			},
		};
	},
};

export const ChannelConverter = {
	Create,
	Entity,
	Update,
};
